module.exports = __webpack_public_path__ + "img/avatarDefault.c65e841a.png";